<template>
  <b-field
    :expanded="is_expanded"
    :label="$t('contact.attributes.title')"
    :label-for="identifier"
  >
    <b-select
      v-if="!is_read_only"
      :id="identifier"
      data-test="select-title"
      :disabled="disabled"
      :expanded="is_expanded"
      :modelValue="title"
      @update:modelValue="(value) => $emit('input', value)"
    >
      <option
        v-for="(title, index) in titles"
        :key="index"
        :value="title"
      >
        {{ $t(`constants.profile_titles.${title}`) }}
      </option>
    </b-select>
    <input
      v-else
      class="input is-static"
      readonly
      :value="$t(`constants.profile_titles.${title}`)"
    />
  </b-field>
</template>

<script>
import { ProfileRecord } from '@/app/data/model_constants';

export default {
  name: 'SelectTitleContact',
  props: {
    title_prop: { type: String, default: null },
    disabled: { type: Boolean, default: false },
    is_expanded: { type: Boolean, default: true },
    is_read_only: { type: Boolean, default: false },
    label: { type: String, default: 'select-title' },
    prefix: { type: String, default: '' },
  },

  emits: ['input'],

  computed: {
    identifier() {
      return _.isEmpty(this.prefix) ? this.label : `${this.prefix}-${this.label}`;
    },

    titles() {
      return _.filter(ProfileRecord.TITLES, (title) => !!this.$t(`constants.profile_titles.${title}`));
    },

    title() {
      return this.title_prop || ProfileRecord.TITLE_SIRMADAM;
    },
  },
};
</script>
